export default {
  state: {
    users: [],
    resetPasswordEmail: null,
  },
  mutations: {
    clearUsers (state) {
      state.users = [];
    },
    setUsers (state, users) {
      state.users = users;
    },
    setResetPasswordEmail (state, resetPasswordEmail) {
      state.resetPasswordEmail = resetPasswordEmail;
    },
  },
  actions: {
    setResetPasswordEmail (context, {resetPasswordEmail}) {
        context.commit('setResetPasswordEmail', resetPasswordEmail);
    },
    async getUsers (context) {
      if (!context.rootState.login.is_client_admin) return;

      context.commit('clearUsers');
      await context.rootState.inst.get(
        '/api/users/',
      ).then((response) => {
        context.commit('setUsers', response.data);
      });
    },
    async deleteUser (context, payload) {
      const url = payload.url;
      await context.rootState.inst.delete(
        url,
      ).then(() => {
        context.dispatch('getUsers');
      });
    },
    async patchUser (context, payload) {
      const url = payload.url;
      const data = payload.data;
      const headers = payload.headers || {};
      await context.rootState.inst.patch(
        url,
        data,
        {headers}
      ).then((response) => {
        if (response.data.id === context.rootState.login.user_id) {
          context.commit('setUserInfo', response.data);
        }
        context.dispatch('getUsers');
      });
    },
    async postUser (context, payload) {
      const data = payload.data;
      await context.rootState.inst.post(
        '/api/users/',
        data,
      ).then(() => {
        context.dispatch('getUsers');
      });
    },
    async resetPasswordUser (context, payload) {
      const email = payload.email;
      await context.rootState.inst.post(
        '/api/auth/password/reset/',
        {email},
      ).then(() => {
        context.dispatch('getUsers');
        context.dispatch('setResetPasswordEmail', {resetPasswordEmail: email});
      });
    },
  }
}